import Apollo from '@adoratorio/apollo';
import aion from '@/scripts/aion';

const apollo = {
  ref: null,
  init() {
    apollo.ref = new Apollo({
      mode: Apollo.FOLLOW.MOUSE,
      targets: [],
      cursor: document.querySelector('.cursor-ball-wrapper'),
      type: Apollo.TYPE.HTML,
      aion,
      renderByPixel: false,
      easing: {
        mode: Apollo.EASING.OUT_CUBIC,
        duration: 1000,
      },
      detectTouch: true,
    });
    return apollo;
  },
};

export default apollo;
